/*
 * This is a Component on the the Top level Page ManagePhotoCollectionPhotos
 */
import React, { useState }                            from 'react'
import axios                                          from 'axios'
import Button                                         from '@material-ui/core/Button'
import Grid                                           from '@material-ui/core/Grid'
import { node_server }                                from '../Helpers'
import PropTypes                                      from 'prop-types'
import SnackBar                                       from '../Atoms/SnackBar'

// this will be needed if the route adds superuser protection
// import { store }                                   from '../Redux/Store'

import TextareaAutosize                               from '@material-ui/core/TextareaAutosize'
import TextField                                      from '@material-ui/core/TextField'
import Typography                                     from '@material-ui/core/Typography'

const AddPhotoCollection = ({CheckToSeeIfACollectionWasAdded}) => {

   // this will be needed if the route adds superuser protection
   // const { signedInUsername } = store.getState()

   const [ description, setDescription ] = useState('')
   const [ name, setName ] = useState('')
   const [ snackBarOpen, setSnackBarOpen ] = useState(false)
   const [ snackBarMessage, setSnackBarMessage ] = useState('')
   const [ snackBarType, setSnackBarType ] = useState('success')

   const descriptionChange = (e) => {
      setDescription(e.target.value)
   }

   const nameChange = (e) => {
      setName(e.target.value)
   }

   const snackBarHandler = ({ msg, type }) => {
      setSnackBarMessage(msg)
      setSnackBarType(type)
      setSnackBarOpen(true)
      setTimeout(() => {
            setSnackBarMessage('')
            setSnackBarType('')
            setSnackBarOpen(false)
      }, 2000)
   }

   const submit = () => {
      axios.post(node_server + 'photoCollection/AddPhotoCollection', {
         photoCollectionName: name,
         photoCollectionDescription: description,

         // this will be needed if the route adds superuser protection
         // signedInUsername
         
      }).then(res => {
         if (res.data.msg === 'NEW Collection saved') {
               setDescription('')
               setName('')
               CheckToSeeIfACollectionWasAdded()
               snackBarHandler({ msg: 'New Collection Created!', typs: 'success'})

         } else if (res.data.message === 'Collection already exists') {
            snackBarHandler({ msg: 'Collection already exists', typs: 'error'})
         }
      })
   }

   return (
      <Grid>
         <Grid item xs={12}>
               <Typography variant='h6'>
                  Add New Photo Collection
               </Typography>
         </Grid>
         <Grid item xs={12}>
               <TextField
                  onChange={nameChange}
                  label='Photo Collection Name'
                  name='photo-collection-name-input'
                  value={name}
                  variant='outlined'
                  style={{
                     width: '60%'
                  }}
               />
         </Grid>
         <Grid item xs={12}>
               <TextareaAutosize
                  data-testid='photo-collection-description-textareaautosize'
                  onChange={descriptionChange}
                  placeholder='Photo Collection Description'
                  minRows={10}
                  value={description}
                  style={{
                     marginTop: '1rem',
                     width: '60%'
                  }}
               />
         </Grid>
         <Grid container item xs={12} style={{width: '100%'}}>
               <Grid item xs={4}>
                  {description.length > 0 && name.length > 0 ?
                     <Button data-testid='submit-button-available' variant='contained' color='primary' style={{marginLeft: '8.5rem', marginTop: '1rem'}} onClick={submit} >
                           Submit
                     </Button>
                     :
                     <Button data-testid='submit-button-not-available' variant='contained' color='primary' disabled style={{marginLeft: '8.5rem', marginTop: '1rem'}} >
                           Submit
                     </Button>
                  }
               </Grid>
               <Grid item xs={5} style={{marginTop: '8px'}} >
                  {snackBarOpen ?
                     <SnackBar msg={snackBarMessage} type={snackBarType} />
                     :
                     null
                  }
               </Grid>
         </Grid>
      </Grid>
   )
}

AddPhotoCollection.propTypes = {
   CheckToSeeIfACollectionWasAdded: PropTypes.func
}

export default AddPhotoCollection
